// Route path constants — the single place a URL is spelled.
// Mirrors the deterministic frontend's src/constants/routes.ts.
export const ROUTES = {
  DASHBOARD: "/",
  MEMBERS: "/members",
  MEMBER_DETAIL: "/members/:memberId",
  MEMBER_NEW: "/members/new",
  MEMBER_ANALYTICS: "/member-analytics",
  MEMBER_ACTIVITY_LOG: "/member-activity-log",
  MEMBER_POPULATION: "/member-population",
  CLUB_RECOMMENDATION: "/club-recommendation",
  NON_MEMBERS: "/non-members",
  EMPLOYEES: "/employees",
  EMPLOYEE_ACTIVITY_LOG: "/employee-activity-log",
  HELPDESK: "/helpdesk",
  HELPDESK_TICKET: "/helpdesk/:ticketId",
  YELLOW_PAGE: "/yellow-page",
  YELLOW_PAGE_CATEGORIES: "/yellow-page-categories",
  PROVINCES: "/provinces",
  CITIES: "/cities",
  BARANGAYS: "/barangays",
  CONFIGURATION: "/configuration",
  ROLES: "/roles",
  PROFILE: "/profile",
  PROFILE_PASSWORD: "/profile/password",
  CHANGE_PASSWORD: "/change-password",
  LOGIN: "/login",
  RESET_PASSWORD_REQUEST: "/reset-password-request",
  SET_PASSWORD: "/set-password",
  COMING_SOON: "/:page",
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
